import { render, staticRenderFns } from "./monthNumberRanking.vue?vue&type=template&id=54a0834c&scoped=true&"
import script from "./monthNumberRanking.vue?vue&type=script&lang=js&"
export * from "./monthNumberRanking.vue?vue&type=script&lang=js&"
import style0 from "./monthNumberRanking.vue?vue&type=style&index=0&id=54a0834c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a0834c",
  null
  
)

export default component.exports